function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import Base from "../Base/Base";
import "./RadialProgress.css";
export default class RadialProgress extends Component {
  render() {
    const {
      children,
      className,
      diameter,
      size,
      sizeRem,
      ...rest
    } = this.props;
    const style = {};
    const classes = classnames(className, "ax-radial-progress", {
      [`ax-radial-progress--${size}`]: size
    });

    if (sizeRem) {
      style.width = sizeRem;
      style.height = sizeRem;
    }

    return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
      Component: "svg",
      className: classes,
      style: style,
      viewBox: `0 0 ${diameter} ${diameter}`
    }), /*#__PURE__*/React.createElement("g", {
      transform: `translate(${diameter / 2}, ${diameter / 2}) rotate(-90)`
    }, children));
  }

}